export const GET_FEED_WAIT = 'GET_FEED_WAITING' //Constants related to feeds/inspiration
export const GET_FEED = 'GET_FEED'
export const GET_FEED_PAGINATION = 'GET_FEED_PAGINATION' //pagination feeds
export const GET_FEED_LOADING = 'GET_FEED_LOADING'
